<template>
    <div class="col-group">
        <TaxinummerLink date="2015" nummer="46" />
        <TaxinummerLink date="2015" nummer="47" />
        <TaxinummerLink date="2015" nummer="48" />
        <TaxinummerLink date="2015" nummer="49" />
        <TaxinummerLink date="2015" nummer="50" />
        <TaxinummerLink date="2015" nummer="51" />
        <TaxinummerLink date="2015" nummer="52" />
        <TaxinummerLink date="2015" nummer="53" />
        <TaxinummerLink date="2015" nummer="54" />
        <TaxinummerLink date="2015" nummer="55" />
    </div>
</template>

<script>
import TaxinummerLink from '@/components/TaxinummerLink';

export default{
    name: 'magazine-2015',
    components: {
        'TaxinummerLink': TaxinummerLink,
    }
}
</script>
